<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {QuestShow} from "@/modules/redactor/models/quest/QuestShow";

export default {
  name: "r-quest-show",
  props: {
    model: VueTypes.instanceOf(QuestShow),
    label: VueTypes.string.def("Appear:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return QuestShow.getValues();
    }
  }
}
</script>